import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { Storage } from "../Storage/Storage"
import { useIdleTimer } from 'react-idle-timer/dist/index.legacy.cjs.js'
import { PlanService } from "../Services"
// import { Storage } from '../Storage/Storage'
const useDetails = Storage.get('auth')

export const Header = () => {
	const history = useHistory();
	const [queryNotes, setQueryNotes] = useState([]);
	const [queryUnread, setQueryUnread] = useState(0);

	const loadQueryNotes = () => {
		PlanService.getQueryNotifications().then((res) => {
			if (res && res.status) {
				setQueryNotes(res.data || []);
				setQueryUnread(Number(res.unread) || 0);
			}
		}).catch(() => {});
	};

	useEffect(() => {
		loadQueryNotes();
		const timer = setInterval(loadQueryNotes, 30000);
		const onRead = () => loadQueryNotes();
		window.addEventListener('plan-queries-read', onRead);
		return () => {
			clearInterval(timer);
			window.removeEventListener('plan-queries-read', onRead);
		};
	}, []);

	const openQueries = () => {
		history.push('/plan-list', { tab: 'custom' });
	};

	function clickevent() {
		document.getElementsByTagName('body')[0].classList.toggle("sidebar-enable");
		document.getElementsByTagName('body')[0].classList.toggle("vertical-collpsed");
	}

	// console.log(useDetails,'useDetails')

	const onIdle = () => {
        Storage.remove('auth')
      }
    
      const { getRemainingTime } = useIdleTimer({
        onIdle,
        timeout: 900_000,
        throttle: 500
      })

	return (
		<header id="page-topbar">
			<div className="navbar-header">
				<div className="d-flex">
					{/* LOGO */}
					<div className="navbar-brand-box">
						<a href="index.html" className="logo logo-dark">
							<span className="logo-sm">
								<img src="/admin/assets/images/logo-sm.png" alt="" height={22} />
							</span>
							<span className="logo-lg">
								<img src="/admin/assets/images/logo_dark.svg" alt="" height={50} />
							</span>
						</a>
						<a href="index.html" className="logo logo-light">
							<span className="logo-sm">
								<img src="/admin/assets/images/logo-sm.png" alt="" height={22} />
							</span>
							<span className="logo-lg">
								<img src="/admin/assets/images/logo-light.png" alt="" height={20} />
							</span>
						</a>
					</div>
					<button
						type="button"
						className="btn btn-sm px-3 font-size-16 header-item"
						onClick={() => clickevent()}
					>

						<i className="fa fa-fw fa-bars" />
					</button>
					{/* App Search*/}
					{/* <form className="app-search d-none d-lg-block">
						<div className="position-relative">
							<input type="text" className="form-control" placeholder="Search..." />
							<span className="uil-search" />
						</div>
					</form> */}
				</div>
				<div className="d-flex">
					<div className="dropdown d-inline-block">
						<button type="button" className="btn header-item noti-icon waves-effect" id="plan-query-bell" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ position: 'relative' }}>
							<i className="uil-bell" />
							{queryUnread > 0 && (
								<span style={{ position: 'absolute', top: '10px', right: '8px', minWidth: '18px', height: '18px', borderRadius: '999px', background: '#ef4444', color: '#fff', fontSize: '11px', fontWeight: 700, lineHeight: '18px', padding: '0 5px' }}>{queryUnread}</span>
							)}
						</button>
						<div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="plan-query-bell" style={{ minWidth: '320px' }}>
							<div className="p-3 border-bottom"><strong>Plan queries</strong></div>
							{queryNotes.length === 0 ? (
								<div className="p-3 text-muted">No new queries</div>
							) : queryNotes.map((item) => (
								<button key={item._id} type="button" className="dropdown-item text-wrap py-2" onClick={openQueries}>
									<div className="d-flex justify-content-between gap-2">
										<strong>{item.company_name}</strong>
										<span className="badge bg-danger">New</span>
									</div>
									<div className="text-muted small">{item.question || item.message || item.email}</div>
								</button>
							))}
							<div className="p-2 border-top text-center">
								<button type="button" className="btn btn-link btn-sm" onClick={openQueries}>Open customize requests</button>
							</div>
						</div>
					</div>
					<div className="dropdown d-inline-block d-lg-none">
						<button type="button" className="btn header-item noti-icon waves-effect" id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<i className="uil-search" />
						</button>
						<div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-search-dropdown">
							<form className="p-3">
								<div className="form-group m-0">
									<div className="input-group">
										<input type="text" className="form-control" placeholder="Search ..." aria-label="Recipient's username" />
										<div className="input-group-append">
											<button className="btn btn-primary" type="submit"><i className="mdi mdi-magnify" /></button>
										</div>
									</div>
								</div>
							</form>
						</div>

					</div>
					<div className="dropdown d-inline-block">
						<button type="button" className="btn header-item waves-effect" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<img className="rounded-circle header-profile-user" src="/admin/assets/images/users/avatar-4.jpg" alt="Header Avatar" />
							<span className="d-none d-xl-inline-block ms-1 fw-medium font-size-15">{useDetails?.admin_name || useDetails?.full_name}</span>
							<i className="uil-angle-down d-none d-xl-inline-block font-size-15" />
						</button>
						<div className="dropdown-menu dropdown-menu-end">
							{/* item*/}
							{/* <a className="dropdown-item" href="#"><i className="uil uil-user-circle font-size-18 align-middle text-muted me-1" /> <span className="align-middle">View Profile</span></a> */}
							{/* <a className="dropdown-item" href="#"><i className="uil uil-wallet font-size-18 align-middle me-1 text-muted" /> <span className="align-middle">My Wallet</span></a>
							<a className="dropdown-item d-block" href="#"><i className="uil uil-cog font-size-18 align-middle me-1 text-muted" /> <span className="align-middle">Settings</span> <span className="badge bg-success rounded-pill mt-1 ms-2">03</span></a>
							<a className="dropdown-item" href="#"><i className="uil uil-lock-alt font-size-18 align-middle me-1 text-muted" /> <span className="align-middle">Lock screen</span></a> */}
							<a className="dropdown-item" onClick={() => Storage.remove('auth')}>
								<i className="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted" />
								<span className="align-middle pointer">Sign out</span></a>
						</div>
					</div>
					{/* <div className="dropdown d-inline-block">
						<button type="button" className="btn header-item noti-icon right-bar-toggle waves-effect">
							<i className="uil-cog" />
						</button>
					</div> */}
				</div>
			</div>
		</header>
	)
}